import get from 'lodash/get';
import { take, takeEvery, put, select } from 'redux-saga/effects';

import { consts as commentsListFetch } from './commentsListFetch';
import { consts as commentsList } from './commentsList';

function* getCommentsWorker(action) {
  const COMMENTS_PER_PAGE = 10;
  const state = yield select();

  const postId = +get(action.payload, 'postId');

  let limit = COMMENTS_PER_PAGE;
  let offset = 0;
  let responseAction = commentsList.LOAD_COMMENTS;

  // eslint-disable-next-line default-case
  switch (action.type) {
    case commentsListFetch.GET_NEW_COMMENTS: {
      limit = get(action.payload, 'limit');
      responseAction = commentsList.LOAD_NEW_COMMENTS;
      break;
    }
    case commentsListFetch.GET_OLDER_COMMENTS: {
      offset = get(state, 'communities.commentsList.length');
      responseAction = commentsList.LOAD_OLDER_COMMENTS;
      break;
    }
  }

  // Request data
  yield put({
    type: commentsListFetch.SEND,
    payload: { postId, limit, offset },
  });

  // Handle response
  const response = yield take(commentsListFetch.SUCCEED);

  yield put({
    type: responseAction,
    payload: response.payload,
  });
}

export function* getCommentsSaga() {
  yield takeEvery(
    [
      commentsListFetch.GET_COMMENTS,
      commentsListFetch.GET_NEW_COMMENTS,
      commentsListFetch.GET_OLDER_COMMENTS,
    ],
    getCommentsWorker,
  );
}



// WEBPACK FOOTER //
// ./src/redux/communities/commentsListSagas.js